/* ROOMS · шапка
   1. Коли прозора шапка біліє, задає CSS: сторож .header__space заввишки 30px (assets/custom.css).
   2. Затримка відкриття меню на комп’ютері: панель відкривається, лише якщо курсор затримався на пункті
      (220 мс; 90 мс, коли інша панель уже відкрита), тож проведений повз шапку курсор нічого не відкриває.
   3. Панель «Бренди»: під курсором показується річ бренду, фото вантажаться при першому відкритті.
   4. Істота на логотипі (snippets/rooms-logo-pet.liquid): раз на 14–24 секунди або при наведенні на логотип
      з’являється здалеку, щоразу з іншого боку, облітає ім’я, сідає на літеру R, O або S і відлітає. */
(function () {
  var header = document.querySelector('[data-section-type="header"]');
  if (!header) return;

  /* ---------- 2. затримка відкриття меню ----------
     Тема відкриває панель на mouseover пункту. Перехоплюємо подію на рівні документа в фазі захоплення
     і передаємо її далі лише тоді, коли курсор пробув на пункті довше за затримку. */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var intentTimer = null, intentTarget = null, passing = false;
    var TRIGGERS = '[data-meganav-trigger], [data-dropdown-trigger]';
    document.addEventListener('mouseover', function (e) {
      if (passing) return;
      var trigger = e.target.closest && e.target.closest(TRIGGERS);
      if (!trigger || !header.contains(trigger)) return;
      e.stopPropagation();
      if (intentTarget === trigger) return;
      clearTimeout(intentTimer);
      intentTarget = trigger;
      var delay = header.classList.contains('dropdown-active') ? 90 : 220;
      intentTimer = setTimeout(function () {
        if (intentTarget !== trigger || !trigger.matches(':hover')) return;
        passing = true;
        trigger.dispatchEvent(new MouseEvent('mouseover', { bubbles: true, cancelable: true, view: window }));
        passing = false;
      }, delay);
    }, true);
    document.addEventListener('mouseout', function (e) {
      if (!intentTarget || !e.target.closest) return;
      var from = e.target.closest(TRIGGERS);
      if (from === intentTarget && !(e.relatedTarget && intentTarget.contains(e.relatedTarget))) {
        clearTimeout(intentTimer);
        intentTarget = null;
      }
    }, true);
  }

  /* ---------- 3. панель «Бренди»: плитка з річчю бренду під курсором ----------
     Фото вантажаться лише тоді, коли панель вперше відкривають (snippets/rooms-brands-meganav.liquid). */
  var brandsNav = header.querySelector('[data-rooms-brands-nav]');
  if (brandsNav) {
    var brandsLoaded = false;
    var loadBrandPics = function () {
      if (brandsLoaded) return;
      brandsLoaded = true;
      brandsNav.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    };
    var brandsTrigger = header.querySelector('[data-meganav-handle="rooms-brands"]');
    if (brandsTrigger) {
      brandsTrigger.addEventListener('mouseenter', loadBrandPics);
      brandsTrigger.addEventListener('focus', loadBrandPics);
    }
    brandsNav.addEventListener('mouseover', function (e) {
      var link = e.target.closest('a[data-brand]');
      if (!link) return;
      loadBrandPics();
      var key = link.getAttribute('data-brand');
      if (!brandsNav.querySelector('.meganav-brands__pic[data-brand="' + key + '"]')) return;
      brandsNav.querySelectorAll('.meganav-brands__pic, .meganav-brands__name').forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute('data-brand') === key);
      });
    });
  }

  /* ---------- 4. істота на логотипі ---------- */
  var pets = Array.prototype.slice.call(header.querySelectorAll('[data-rooms-pet]'));
  if (!pets.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!(window.CSS && CSS.supports && CSS.supports('offset-path', 'path("M0 0L1 1")'))) return;

  /* Маршрути намальовані для логотипа завширшки 100px і масштабуються під справжню ширину.
     Кожен приліт закінчується, а кожен відліт починається рухом угору, тож істота сідає і злітає головою догори. */
  var ROUTES_IN = [
    { to: 'S', p: [['M', 158, -46], ['C', 122, -42, 80, -30, 44, -20], ['C', 16, -13, -14, 2, -2, 17], ['C', 8, 30, 48, 33, 72, 25], ['C', 88, 19, 93, 13, 93, -2]] },
    { to: 'S', p: [['M', 50, -62], ['C', 96, -60, 130, -30, 116, -6], ['C', 106, 10, 84, 16, 76, 8], ['C', 72, 4, 93, 12, 93, -2]] },
    { to: 'O', p: [['M', -44, -30], ['C', -10, -34, 40, -32, 96, -18], ['C', 118, -10, 112, 14, 90, 24], ['C', 70, 32, 54, 28, 50, 14], ['C', 50, 8, 50, 2, 50, -3]] },
    { to: 'O', p: [['M', -36, 50], ['C', -10, 20, 30, -20, 80, -26], ['C', 110, -30, 120, -8, 100, 2], ['C', 84, 10, 60, 14, 50, 10], ['C', 48, 6, 50, 2, 50, -3]] },
    { to: 'R', p: [['M', 140, 40], ['C', 120, 10, 100, -24, 60, -26], ['C', 24, -28, -20, -16, -22, 6], ['C', -24, 20, -4, 26, 7, 14], ['C', 10, 8, 8, 2, 7, -2]] }
  ];
  var ROUTES_OUT = {
    S: [[['M', 93, -2], ['C', 93, -14, 104, -24, 118, -30], ['C', 136, -38, 152, -48, 168, -62]], [['M', 93, -2], ['C', 93, -16, 70, -26, 40, -26], ['C', 10, -26, -14, -40, -40, -60]]],
    O: [[['M', 50, -3], ['C', 50, -16, 70, -30, 100, -34], ['C', 130, -38, 150, -52, 170, -66]], [['M', 50, -3], ['C', 50, -16, 30, -30, 0, -36], ['C', -20, -40, -36, -54, -50, -70]]],
    R: [[['M', 7, -2], ['C', 7, -16, 30, -30, 60, -30], ['C', 90, -30, 120, -44, 150, -64]], [['M', 7, -2], ['C', 7, -14, -6, -26, -22, -34], ['C', -36, -42, -46, -56, -56, -72]]]
  };
  var TIMES = { butterfly: { inn: 3500, sit: 1400, out: 1800 }, bird: { inn: 2700, sit: 1200, out: 1400 } };

  function scaled(path, k) {
    return 'path("' + path.map(function (seg) {
      return seg[0] + seg.slice(1).map(function (n) { return (n * k).toFixed(1); }).join(' ');
    }).join(' ') + '")';
  }

  var state = 'hidden', timer = null, lastIn = -1;

  /* на екрані одночасно лише один рядок шапки (десктопний або мобільний), тож і істота одна */
  function visiblePet() {
    for (var i = 0; i < pets.length; i++) if (pets[i].offsetParent !== null) return pets[i];
    return null;
  }

  function visit() {
    if (state !== 'hidden' || document.hidden) return;
    var pet = visiblePet();
    if (!pet) return;
    var logo = pet.parentNode, k = logo.offsetWidth / 100;
    if (!k) return;

    var i;
    do { i = Math.floor(Math.random() * ROUTES_IN.length); } while (i === lastIn);
    lastIn = i;
    var inn = ROUTES_IN[i], outs = ROUTES_OUT[inn.to], out = outs[Math.floor(Math.random() * outs.length)];
    pet.style.setProperty('--rooms-pet-size', (15 * k).toFixed(1) + 'px');
    pet.style.setProperty('--rooms-pet-in', scaled(inn.p, k));
    pet.style.setProperty('--rooms-pet-out', scaled(out, k));

    var t = TIMES[pet.getAttribute('data-rooms-pet')] || TIMES.butterfly;
    state = 'in';
    pet.className = 'rooms-pet is-in';
    setTimeout(function () {
      state = 'sit';
      pet.className = 'rooms-pet is-sit';
      setTimeout(function () {
        state = 'out';
        pet.className = 'rooms-pet is-out';
        setTimeout(function () {
          state = 'hidden';
          pet.className = 'rooms-pet';
          schedule();
        }, t.out);
      }, t.sit + Math.random() * 1800);
    }, t.inn);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { visit(); if (state === 'hidden') schedule(); }, 14000 + Math.random() * 10000);
  }

  pets.forEach(function (pet) { pet.parentNode.addEventListener('mouseenter', visit); });
  setTimeout(function () { visit(); if (state === 'hidden') schedule(); }, 1800);
})();
